export function generateCsvLinkFromSrc(
  url: string,
  sheetName?: string
): string {
  const srcUrl = new URL(url);
  const sheetId = srcUrl.pathname.split("/")[3];
  return `https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?tqx=out:csv${
    sheetName ? `&sheet=${sheetName}` : ""
  }`;
}
